<template>
  <a
    id="profile-menu"
    class="profile-btn">
    <span class="initials">{{ initialsFromString }}</span>

    <v-menu
      activator="#profile-menu"
      open-on-hover
      class="profile-menu"
      v-model="showMenu">
      <v-row class="pt-4 pb-5 d-flex align-center">
        <v-col cols="3">
          <span class="initials-round">{{ initialsFromString }}</span>
        </v-col>
        <v-col
          cols="9"
          class="pl-5">
          <h4>{{ fullName }}</h4>
          <p>
            <small>{{ emailAddress }}</small>
          </p>
          <p>
            <small>{{ phoneNumber }}</small>
          </p>
        </v-col>
      </v-row>

      <div
        class="version"
        data-test="version"
        @click.prevent.stop="showApi = true"
        v-show="!showApi">
        Version: {{ appInfo.getAppVersion() }} •
        Build: {{ appInfo.getBuildNumber() ?? "Dev" }} • 
        Built: {{ dayjs(appInfo.getBuildDate()).format("YYYY-MM-DD HH:mm:ss") }}
      </div>
      <div
        class="version"
        v-show="showApi"
        @click.prevent.stop="showApi = false">
        API Version: {{ apiAppInfo?.version }} •
        Build: {{ apiAppInfo?.buildNumber }} •
        Built: {{ dayjs(apiAppInfo?.buildDate).format("YYYY-MM-DD HH:mm:ss") }}
      </div>

      <router-link
        to="/logout"
        class="sign-out"><small>Sign out</small></router-link>
    </v-menu>
  </a>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user.store";
import { computed, ref } from "vue";
import * as appInfo from "@/lib/appInfo";
import dayjs from "dayjs";
import useApiAppInfo from "@/composables/useApiAppInfo";

const userStore = useUserStore();
const { apiAppInfo } = useApiAppInfo();

const emailAddress = ref(userStore.self?.email);
const phoneNumber = ref(userStore.self?.contactPhone);
const fullName = ref(userStore.self?.name);
const showApi = ref(false);
const showMenu = ref();

const initialsFromString = computed(() => {
  const names = fullName.value?.split(" ") || [];
  const firstInitial = names[0]?.charAt(0).toUpperCase();
  if (names.length === 1) {
    return firstInitial || "";
  } else {
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }
});

</script>

<style lang="scss">
  .profile-btn {
    background-color: var(--c-teal-dark);
    padding: 0 0.75rem;
    position: absolute;
    right: 0;
    top: 0;
    .initials {
      font-size: 2rem;
      color: white;
    }
  }

  .profile-menu {
    color: black;
    a {
      cursor: pointer;
      color: var(--c-teal);
    }
    p {
      line-height: 1rem;
    }
    .v-overlay__content {
      background-color: var(--c-grey-lighter);
      padding: 1rem;
      border-radius: 0;
      right: 0 !important;
      left: auto !important;
      max-width: 375px !important;
      width: 100%;
      box-shadow: var(--v-menu-shadow);
    }
    .sign-out {
      position: absolute;
      top: 0rem;
      right: 0.4rem;
    }

    .initials-round {
      background-color: var(--c-teal-light);
      color: white;
      border-radius: 50%;
      width: 5rem;
      height: 5rem;
      font-size: 2rem;
      display: block;
      text-align: center;
      padding-top: 0.875rem;
    }

    .version {
      font-size: x-small;
      color: var(--c-grey-dark);
      position: absolute;
      bottom: 3px;
      cursor: pointer;
    }
  }
</style>
